<template>
  <transition-group
    tag="div"
    name="fade"
    appear
  >
    <div class="fixed-top" key="error" style="z-index: 9999;">
      <div class="container">
        <div
          v-for="error in errors"
          :key="error"
          class="mt-4 w-50 m-auto"
        >
          <div
            class="alert alert-danger alert-dismissible shadow-lg"
            role="alert"
          >
            <font-awesome-icon :icon="['far', 'triangle-exclamation']" />
            {{ error }}
            <button
              type="button"
              class="btn-close"
              @click="removeError(error)"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </transition-group>

  <transition-group
    tag="div"
    name="fade"
    appear
  >
    <div class="fixed-top" key="success" style="z-index: 9999;">
      <div class="container">
        <div
          v-for="success in successes"
          :key="success"
          class="mt-4 w-50 m-auto"
        >
          <div
            class="alert alert-success alert-dismissible shadow-lg"
            role="alert"
          >
            <font-awesome-icon :icon="['far', 'check-circle']" />
            {{ success }}
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
              @click="removeSuccess(success)"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </transition-group>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: "ErrorSuccessMessage",
    computed: {
      ...mapState(["errors", "successes"]),
    },
    methods: {
      removeError(error) {
        const newErrors = this.errors.filter((item) => item !== error);
        this.$store.commit("errors", newErrors);
      },
      removeSuccess(success) {
        const newSuccess = this.successes.filter((item) => item !== success);
        this.$store.commit("successes", newSuccess);
      },
    },
    unmounted() {
      this.$store.commit("errors", []);
      this.$store.commit("successes", []);
    },
  };
</script>

<style scoped>
  .fade-enter-active {
    animation: fade-in 0.5s;
  }

  .fade-leave-active {
    animation: fade-in 1s reverse;
  }

  @keyframes fade-in {
    from {
      opacity: 0;
      margin-top: -50px;
      margin-bottom: 50px;
    }
    to {
      opacity: 1;
      width: 100%;
      margin-top: 0px;
      margin-bottom: 0px;
    }
  }
</style>
